import SiteHeader from "@/components/SiteHeader";
import Hero from "@/components/Hero";
import PracticeGrid from "@/components/home/PracticeGrid";
import LegislationShowcase from "@/components/home/LegislationShowcase";
import TikTokIdeasSection from "@/components/hero/TikTokIdeasSection";
import SupportingEvidenceSection from "@/components/hero/SupportingEvidenceSection";
import PartnerNetwork from "@/components/PartnerNetwork";
import GrantFinder from "@/components/GrantFinder";
import ProofSection from "@/components/home/ProofSection";
import CallToAction from "@/components/CallToAction";
import SiteFooter from "@/components/SiteFooter";
import MissionFocusCard from "@/components/home/MissionFocusCard";
import HomeStatsRow from "@/components/home/HomeStatsRow";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SiteHeader variant="hero" />
      <Hero />

      {/* Mission + focus areas */}
      <MissionFocusCard />

      {/* Stat summary cards (Legislation + Grants) */}
      <HomeStatsRow />

      {/* Practice Overview */}
      <PracticeGrid />

      {/* Practice 01 — Lobbying (Map + Legislation Tracker) */}
      <LegislationShowcase />

      {/* Practice 02 — Strategic Communication */}
      <div id="signal">
        <TikTokIdeasSection />
      </div>

      {/* Practice 03 — Advocacy */}
      <div id="partners">
        <PartnerNetwork />
      </div>

      {/* Practice 04 — Research */}
      <div id="evidence">
        <SupportingEvidenceSection />
      </div>

      {/* Practice 05 — Economic Development */}
      <div id="grants">
        <GrantFinder />
      </div>

      {/* Outcomes */}
      <div id="proof">
        <ProofSection />
      </div>

      <CallToAction />
      <SiteFooter />
    </div>
  );
};

export default Index;
